import { BaseEntity } from '../../base-entity';
import { PaymentMethodsDb } from '../../students/payment-services/user-payments/user-payment-service-with-price-list';

export enum JournalEntryStatus {
  PENDING = 'pending',
  EXPORTED = 'exported',
}

export enum BusinessEventType {
  PAYMENT_RECEIVED = 'payment_received',
  DEPOSIT = 'deposit',
  PAYMENT_CANCELLED = 'payment_cancelled',
  PAYMENT_REFUNDED = 'payment_refunded',
  CHECK_BOUNCED = 'check_bounced',
}

export interface JournalEntryEntity extends BaseEntity {
  id: number;
  journalExportId: number | null;
  businessEventType: BusinessEventType;
  entryDate: Date;
  status: JournalEntryStatus;
  paymentMethodType: PaymentMethodsDb;
  userPaymentId: number | null;
  userPaymentCheckId: number | null;
  crmPaymentId: number | null;
  crmCheckId: number | null;
  depositId: number | null;
  depositPaymentId: number | null;
  valueDate: Date | null;
  documentNumber: number | null;
  paymentReference: string | null;
  details: string | null;
  paymentDescription: string | null;
}
